import React from 'react';
import { SendIcon, MessageCircleIcon } from 'lucide-react';
export const Footer = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <footer className="w-full py-12 px-6 md:px-10 bg-gradient-to-br from-[#2c5f2d] to-[#1f4520] text-white" data-id="element-125">
      <div className="max-w-7xl mx-auto" data-id="element-126">
        <div className="grid md:grid-cols-3 gap-10 mb-10" data-id="element-127">
          {/* Left - About */}
          <div className="space-y-4" data-id="element-128">
            <div className="flex items-center gap-2" data-id="element-129">
              <div className="text-2xl font-bold" data-id="element-130">МБ</div>
              <div className="h-6 w-px bg-white/30" data-id="element-131"></div>
              <div className="text-sm uppercase tracking-widest text-white/80" data-id="element-132">
                Психолог
              </div>
            </div>
            <p className="text-sm text-white/80 leading-relaxed" data-id="element-133">
              Клинический психолог, психотерапевт. Индивидуальная, парная и
              групповая терапия онлайн и очно в Париже.
            </p>
          </div>
          {/* Center - Navigation */}
          <div className="space-y-4" data-id="element-134">
            <h3 className="text-base font-semibold uppercase tracking-wider" data-id="element-135">
              Навигация
            </h3>
            <nav className="flex flex-col gap-2" data-id="element-136">
              <button onClick={() => scrollToSection('about')} className="text-white/80 hover:text-white transition-colors text-sm text-left" data-id="element-137">
                Обо мне
              </button>
              <button onClick={() => scrollToSection('services')} className="text-white/80 hover:text-white transition-colors text-sm text-left" data-id="element-138">
                Услуги и цены
              </button>
              <button onClick={() => scrollToSection('testimonials')} className="text-white/80 hover:text-white transition-colors text-sm text-left" data-id="element-139">
                Отзывы
              </button>
              <button onClick={() => scrollToSection('education')} className="text-white/80 hover:text-white transition-colors text-sm text-left" data-id="element-140">
                Образование
              </button>
            </nav>
          </div>
          {/* Right - Contact */}
          <div className="space-y-4" data-id="element-141">
            <h3 className="text-base font-semibold uppercase tracking-wider" data-id="element-142">
              Контакты
            </h3>
            <div className="space-y-3" data-id="element-143">
              <a href="https://t.me/mbrodskaya" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white/80 hover:text-white transition-colors group" data-id="element-144">
                <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center group-hover:bg-white/20 transition-colors" data-id="element-145">
                  <SendIcon className="w-4 h-4" data-id="element-146" />
                </div>
                <span className="text-sm" data-id="element-147">Telegram</span>
              </a>
              <a href="https://wa.me/79218451514" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-white/80 hover:text-white transition-colors group" data-id="element-148">
                <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center group-hover:bg-white/20 transition-colors" data-id="element-149">
                  <MessageCircleIcon className="w-4 h-4" data-id="element-150" />
                </div>
                <span className="text-sm" data-id="element-151">WhatsApp</span>
              </a>
            </div>
          </div>
        </div>
        {/* Bottom - Copyright */}
        <div className="pt-8 border-t border-white/20 text-center" data-id="element-152">
          <p className="text-sm text-white/60" data-id="element-153">
            © 2025 Мария Бродская. Все права защищены.
          </p>
        </div>
      </div>
    </footer>;
};